export default __webpack_public_path__ + "static/media/woodfloorbefore.2fb76666.jpg";